const handleNumberKeyPress = (event, allowDot = true) => {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete']
  if (allowedKeys.includes(event.key)) {
    return
  }

  const isNumber = /[0-9]/.test(event.key)
  if (!isNumber && !allowDot) {
    event.preventDefault()
    return
  }
  const input = event.target
  const isDot = event.key === '.'
  const hasDot = event.target.value.includes('.')

  if (!isNumber && !(isDot && !hasDot && input.value.length > 0)) {
    event.preventDefault()
  }
}

export { handleNumberKeyPress }
